import { DropdownSelect } from '@components/common/DropdownSelect';
import { useAppSelector } from '@hooks/useRedux';
import { selectCurrentUser } from '@store/auth/authSelectors';
import React from 'react';
import avatarSvg from '../../assets/avatar.svg';
import { useDashboardContext } from './DashboardContext';
import { getUserName } from './helpers';

const PERIOD_OPTIONS = [
  { value: '1', label: 'Today' },
  { value: '7', label: 'Last 7 Days' },
  { value: '30', label: 'Last 30 Days' },
  { value: '90', label: 'Last 3 Months' },
  { value: '365', label: 'Last 12 Months' },
];

export const DashboardHeader: React.FC = () => {
  const { period, setPeriod } = useDashboardContext();
  const currentUser = useAppSelector(selectCurrentUser);
  const name = getUserName(currentUser?.first_name, currentUser?.last_name);
  return (
    <div className="mb-6 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 overflow-hidden rounded-full bg-emerald-100">
          <img
            src={avatarSvg}
            alt="Avatar"
            className="h-full w-full object-cover"
          />
        </div>
        <div>
          <h1 className="flex items-center gap-2 text-lg font-bold text-slate-900">
            Welcome, {name.split(' ')[0]} <span className="text-lg">👋</span>
          </h1>
          <p className="text-[11px] text-slate-500">
            Your financial overview for today
          </p>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <DropdownSelect
          value={String(period)}
          onChange={(v) => setPeriod(Number(v))}
          options={PERIOD_OPTIONS}
        />
      </div>
    </div>
  );
};
